<template>
  <div class="d-flex pl-1">
    <div class="d-flex align-start">
      <span v-if="price != maxPrice" class="body-2" style="margin-top: 5px; margin-right: 3px;">from</span>
      <the-price :price="price" />
    </div>
  </div>
</template>
<script>
import thePrice from './thePrice.vue';
export default {
  name: 'ProductPrice',
  components: { thePrice },
  props: {
    product: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed: {
    price: function () {
      if (this.product.variants) {
        let min = Infinity;

        for (const variant of this.product.variants) {
          if (variant.price < min) {
            min = variant.price;
          }
        }
        return min;
      }
      return null;
    },
    maxPrice: function () {
      if (this.product.variants) {
        let max = 0;

        for (const variant of this.product.variants) {
          if (variant.price > max) {
            max = variant.price;
          }
        }
        return max;
      }
      return null;
    }
  }
};
</script>
